import { useEffect } from "react";

import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";

import { spotOnLogin } from "@/apis/login";
import {
  DASHBOARD_URL,
  HOME_MAIN_URL,
  LOGIN_MAIN_URL,
  LOGIN_QR_URL,
  LOGIN_SIGNUP_URL,
} from "@/constants/routes";
import useLoginStore from "@/store/loginStore";
import useUserStore from "@/store/userStore";

const useLoginCheck = (kakaoToken: string) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { spotOnToken, expiredAt, saveSpotOnToken, saveTokenId } = useLoginStore();
  const roleId = useUserStore(state => state.roleId);
  const isAdmin = roleId === "ADMIN" || roleId === "MINISTRY";

  useEffect(() => {
    if (
      location.pathname !== "/kakao/auth" &&
      !location.pathname.includes("/view/main")
    ) {
      // SpotOn JWT가 유효하면 카카오 재검증 스킵
      if (spotOnToken && expiredAt && dayjs().isBefore(dayjs(expiredAt))) {
        if (location.pathname.includes("/login")) {
          navigate(isAdmin ? DASHBOARD_URL : HOME_MAIN_URL);
        }
        return;
      }

      if (kakaoToken.length > 0) {
        loginCheck();
      } else if (location.pathname !== "/login/main") {
        navigate(LOGIN_MAIN_URL);
      }
    }
  }, [kakaoToken]);

  const loginCheck = async () => {
    const { status, token, tokenId, userStateCode } =
      await spotOnLogin(kakaoToken);

    if (status === 412) {
      navigate(LOGIN_SIGNUP_URL, { state: kakaoToken });
    } else if (status === 200 && userStateCode === "00") {
      // 승인 대기 회원: JWT 를 저장하지 않고 대기 화면에 머물게 한다
      if (location.pathname !== LOGIN_QR_URL) {
        navigate(LOGIN_QR_URL, { replace: true });
      }
    } else if (status === 200) {
      saveSpotOnToken(token);
      saveTokenId(tokenId);

      if (location.pathname.includes("/login")) {
        navigate(isAdmin ? DASHBOARD_URL : HOME_MAIN_URL);
      }
    }
  };

  return <div></div>;
};

export default useLoginCheck;
